import "./title.css"

const font = "'Noto Sans TC', sans-serif"

    export const titleText = {
        fontFamily: font,
        fontSize: "20px",
        minHeight: "37px"
    },
    locationIcon = {
        color: "#9e9e9e",
        marginLeft: "20px"
    },
    locationText = {
        fontFamily: font,
        fontSize: "14px",
        color: "#0E0E0F"
    },
    divDivider = {
        paddingTop: "9px"
    }

